import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue";
import Inicio from "./components/Inicio.vue";
import Login from "./components/Login.vue";
import Adm_estado from "./components/Adm_estado.vue";
import Adm_users from "./components/Adm_users.vue";
import Adm_perfil from "./components/Perfil/Adm_perfil.vue";
import Perfil from "./components/Perfil/Perfil.vue";
import Div_archiv from "./components/Division/Div_archiv.vue";
import Adm_funcionario from "./components/Perfil/Adm_funcionario.vue";
import Div_mapa from "./components/Division/Div_mapa.vue";
import Adm_nivel from "./components/Admin/Adm_nivel.vue";
import Adm_cargo from "./components/Admin/Adm_cargo.vue";
import Adm_unidad from "./components/Admin/Adm_unidad.vue";
import Adm_destino from "./components/Admin/Adm_destino.vue";
import Adm_grado from "./components/Admin/Adm_grado.vue";
import Div_planeamiento from "./components/Division/Div_planeamiento.vue";
import Div_movimiento from "./components/Division/Div_movimiento.vue";
import Div_regimen from "./components/Division/Div_regimen.vue";
import Div_evaluacion from "./components/Division/Div_evaluacion.vue";
import Div_salud from "./components/Division/Div_salud.vue";
import Div_activos from "./components/Division/Div_activos.vue";
import Div_planilla from "./components/Division/Div_planilla.vue";
import Div_academica from "./components/Division/Div_academica.vue";
import Div_nomina from "./components/Division/Div_nomina.vue";
import Dashboard from "./components/Reporte/Dashboard.vue";
import Detalle_funcionario from "./components/Perfil/Detalle_funcionario.vue";
import Adm_cas from "./components/Admin/Adm_cas.vue";
import Adm_frontera from "./components/Admin/Adm_frontera.vue";
import Adm_gradopolicial from "./components/Admin/Adm_gradopolicial.vue";
import Adm_funciones from "./components/Admin/Adm_funciones.vue";
import Adm_catalogo from "./components/Admin/Adm_catalogo.vue";
import Rep_distribucion from "./components/Reporte/Rep_distribucion.vue";
import Rep_dinamico from "./components/Reporte/Rep_dinamico.vue";
import Rep_grafico_dinamico from "./components/Reporte/Rep_grafico_dinamico.vue";
import EnDesarrollo from "./components/EnDesarrollo.vue";
import ImportarCorreosFuncionarios from "./components/Perfil/ImportarCorreosFuncionarios.vue";
import AuditoriaLog from "./components/Reporte/AuditoriaLog.vue";

Vue.use(Router);

const router =  new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "login",
            component: Login,
        },
        /*{
        path: "/",
        name: "Home",
        component: Home,
        },*/ 
        {
            path: "/Home",
            component: Inicio,
            meta: { requiresAuth: true},
            children: [
                {
                    path: "",
                    name: "Home",
                    component: Home,
                },
                {
                    path: "estado",
                    name: "estado",
                    component: Adm_estado,
                },
                {
                    path: "user",
                    name: "user",
                    component: Adm_users,
                },
                {
                    path: "funcionario",
                    name: "funcionario",
                    component: Adm_funcionario,
                },
                {
                    path: "perfil",
                    name: "perfil",
                    component: Perfil,
                },
                {
                    path: "perfils",
                    name: "perfils",
                    component: Adm_perfil,
                },
                {
                    path: "archivo",
                    name: "archivo",
                    component: Div_archiv,
                },
                {
                    path: "map",
                    name: "map",
                    component: Div_mapa,
                },
                {
                    path: "admNivel",
                    name: "admNivel",
                    component: Adm_nivel,
                },
                {
                    path: "admCargo",
                    name: "admCargo",
                    component: Adm_cargo,
                },
                {
                    path: "admUnidad",
                    name: "admUnidad",
                    component: Adm_unidad,
                },
                {
                    path: "admDestino",
                    name: "admDestino",
                    component: Adm_destino,
                },
                {
                    path: "admGrado",
                    name: "admGrado",
                    component: Adm_grado,
                },
                {
                    path: "admPlaneamiento",
                    name: "admPlaneamiento",
                    component: Div_planeamiento,
                },
                {
                    path: "admMovimiento",
                    name: "admMovimiento",
                    component: Div_movimiento,
                },
                {
                    path: "admRegimen",
                    name: "admRegimen",
                    component: Div_regimen,
                },
                {
                    path: "admEvaluacion",
                    name: "admEvaluacion",
                    component: Div_evaluacion,
                },
                {
                    path: "admSalud",
                    name: "admSalud",
                    component: Div_salud,
                },
                {
                    path: "admActivos",
                    name: "admActivos",
                    component: Div_activos,
                },
                {
                    path: "admPlanilla",
                    name: "admPlanilla",
                    component: Div_planilla,
                },
                {
                    path: "admAcademica",
                    name: "admAcademica",
                    component: Div_academica,
                },
                {
                    path: "admNomina",
                    name: "admNomina",
                    component: Div_nomina,
                },
                {
                    path: "dashboard",
                    name: "dashboard",
                    component: Dashboard,
                },
                {
                    path: "detalleF",
                    name: "detalleF",
                    component: Detalle_funcionario,
                },
                {
                    path: "admCas",
                    name: "admCas",
                    component: Adm_cas,
                },
                {
                    path: "admFunciones",
                    name: "admFunciones",
                    component: Adm_funciones,
                },
                {
                    path: "admGPolicial",
                    name: "admGPolicial",
                    component: Adm_gradopolicial,
                },
                {
                    path: "admFrontera",
                    name: "admFrontera",
                    component: Adm_frontera,
                },
                {
                    path: "admCatalogo",
                    name: "admCatalogo",
                    component: Adm_catalogo,
                },
                {
                    path: "repDistribucion",
                    name: "repDistribucion",
                    component: Rep_distribucion,
                },
                {
                    path: "repDinamico",
                    name: "repDinamico",
                    component: Rep_dinamico,
                },
                {
                    path: "repGDinamico",
                    name: "repGDinamico",
                    component: Rep_grafico_dinamico,
                },
                {
                    path: "enDesarrollo",
                    name: "enDesarrollo",
                    component: EnDesarrollo,
                },
                {
                    path: "actCorreos",
                    name: "actCorreos",
                    component: ImportarCorreosFuncionarios,
                },
                {
                    path: "log",
                    name: "log",
                    component: AuditoriaLog,
                },
            ]
        },
        
    ],
});
export default router;